import {bp} from '../core/namespace.js';

$.extend(true, bp, {
  leaflet: (function () {
    var map;
    var plotlayers = [];
    var opts = {
      latitude: 52.006370,
      longitude: 5.034112,
      zoom: 7,
      data_url: undefined,
      load_markers_callback: undefined,
      map_style: '',
      link: undefined,
    };

    return {
      init: function (custom_opts) {
        custom_opts = typeof custom_opts !== 'undefined' ? custom_opts : {};
        $.extend(true, opts, custom_opts);

        if (isNaN(opts.latitude) || isNaN(opts.longitude) || isNaN(opts.zoom)) {
          opts.latitude = 52;
          opts.longitude = 5.8;
          opts.zoom = 7;
        }
        var map_options = {
          zoom: opts.zoom,
          fullscreenControl: true,
          fullscreenControlOptions: {
            position: 'topright',
            title: 'Volledig scherm',
            titleCancel: 'Verlaat volledig scherm',
          },
        };

        if ($(window).width() < 768) {
          $.extend(map_options, {
            gestureHandling: true,
          });
        }

        var myIcon = L.icon({
          iconUrl: static_url + 'img/maps/default-icon.png',
          shadowUrl: static_url + 'img/maps/default-icon-shadow.png',
          iconAnchor: [10, 20],
        });

        if (opts.map_style === 'esofdetail') {
          $.extend(map_options, {
            zoomControl: true,
          });
        }

        map = new L.Map('map-canvas', map_options);

        var osmUrl = 'https://{s}.tile.openstreetmap.de/{z}/{x}/{y}.png';
        var osmAttrib = 'Map data © <a href="https://openstreetmap.org">OpenStreetMap</a> contributors';
        var osm = new L.TileLayer(osmUrl, {minZoom: 8, maxZoom: 19, attribution: osmAttrib});

        map.setView(new L.LatLng(opts.latitude, opts.longitude), opts.zoom);
        map.addLayer(osm);

        if (opts.map_style == 'esofdetail') {
          L.marker([opts.latitude, opts.longitude], {icon: myIcon}).addTo(map);
          map.doubleClickZoom.disable();
          $('.map-wrapper-mobile').removeClass('hide-on-load');
          $('.map-wrapper-inner-mobile').removeClass('hide-on-load');
        }
      },
      removeMarkers: function () {
        for (var i = 0; i < plotlayers.length; i++) {
          map.removeLayer(plotlayers[i]);
        }
        plotlayers = [];
      },
      addMarkers: function (plotlist) {
        for (var i = 0; i < plotlist.length; i++) {
          var plotll = new L.LatLng(plotlist[i].lat, plotlist[i].lon, true);
          var plotmark = new L.Marker(plotll);
          plotmark.data = plotlist[i];
          map.addLayer(plotmark);
          plotmark.bindPopup('<h3>' + plotlist[i].name + '</h3>' + plotlist[i].details);
          plotlayers.push(plotmark);
        }
      },
    };
  })(),
});

window.bp_leaflet = {map: bp.leaflet};

export {bp};
